import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step13 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("typeOfLook");

  const handleOptionClick = (value) => {
    onAnswer("typeOfLook", value);
  };

  return (
    <QuizContent className="gridContent ">
      <QuizTitle className="gridTitle">Which type of look attracts you the most?</QuizTitle>
      <QuizOptions className="QuizOptionsGrid step13 gridOptions">
        {quizOptions.map((option) => (
          <QuizOption
            key={option.value}
            value={option.value}
            name="typeOfLook"
            onClick={handleOptionClick}
            hasIcon={option.hasIcon}
          >
            {option.hasIcon && (
              <picture>
                <img
                  src={option.image}
                  className="option-icon"
                  alt={option.alt}
                />
              </picture>
            )}
            <div>
              <p>
                <strong>{option.text}</strong>
              </p>
            </div>
          </QuizOption>
        ))}
      </QuizOptions>
    </QuizContent>
  );
};

export default Step13;
